module.exports = __webpack_public_path__ + "static/img/banner.9786ab25.png";